// extracted by mini-css-extract-plugin
export var activeDot = "_2p-c";
export var buttonContainer = "_2p-9";
export var channelButton = "_2p-a";
export var clickable = "_2p-d";
export var content = "_2p-0";
export var contentFull = "_2p-2";
export var contentThird = "_2p-1";
export var contentWrapper = "_2p-7";
export var description = "_2p-5";
export var heightShort = "_2p-f";
export var image = "_2p-3";
export var imageContainer = "_2p-4";
export var selectButton = "_2p-e";
export var spinnerContainer = "_2p-b";
export var titleContent = "_2p-8";
export var titleWrapper = "_2p-6";